export const config = {
  title: "Ahmed Human Services LLC | Columbus, OH",
  meta: {
    description:
      "Ahmed Human Services LLC is a professional, compassionate human service staffing agency in Columbus, Ohio. We provide exceptional care for individuals with disabilities, elderly care, mental health support, and staffing for group homes, hospitals, and residential facilities.",
    keywords: [
      "Ahmed Human Services LLC",
      "Human Services Columbus Ohio",
      "Disability Care Staffing",
      "Group Home Staffing Columbus",
      "Residential Care Staffing",
      "Mental Health Care Ohio",
      "Elderly Care Services",
      "Hospital Support Staff",
      "One on One Care",
      "Rehabilitation Center Staffing"
    ],
    author: "Ahmed Human Services LLC",
    canonicalUrl: "https://www.ahmedservicesllc.org/",
  },
  sections: {
    header: {
      businessName: "Ahmed Human Services LLC",
    },
    sectionB: {
      heroTitle: "Compassionate Care, Professional Service",
      heroSubtitle: "Quality Human Service Staffing Solutions in Columbus, Ohio",
      learnAboutText: "Contact Us for Staffing",
      phoneNumber: "8573987451",
      phoneLabel: "(857) 398-7451",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?q=80&w=2031&auto=format&fit=crop",
      cardData: [
        {
          title: "One-on-One Care",
          description:
            "Dedicated, personalized care for individuals requiring focused attention and support.",
        },
        {
          title: "Group Home Staffing",
          description:
            "Professional staffing solutions for group homes and residential care facilities.",
        },
        {
          title: "Hospital Support",
          description:
            "Reliable hospital support assistance available around the clock.",
        },
      ],
      description:
        "Ahmed Human Services LLC is a professional, compassionate, and dedicated human service staffing agency serving Columbus, Ohio. We work with individuals with various disabilities, provide mental health care, elderly care, and support across multiple care settings.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We provide comprehensive human service staffing solutions with a commitment to quality care and professionalism. Available to you 24/7.",
      cards: [
        {
          title: "One-on-One Care",
          description:
            "Personalized, dedicated care services for individuals who need focused, attentive support in various settings.",
          imageSrc: "https://images.unsplash.com/photo-1581579438747-1dc8d17bbce4?q=80&w=2070&auto=format&fit=crop",
          imageAlt: "One-on-One Care Services",
        },
        {
          title: "Group Homes & Residential Staffing",
          description:
            "Professional staffing for group homes, residential care facilities, and rehabilitation centers with trained, compassionate caregivers.",
          imageSrc: "https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?q=80&w=2078&auto=format&fit=crop",
          imageAlt: "Group Home Staffing",
        },
        {
          title: "Hospital Support Assistance",
          description:
            "Round-the-clock hospital support services to ensure timely and reliable care delivery.",
          imageSrc: "https://images.unsplash.com/photo-1538108149393-fbbd81895907?q=80&w=2128&auto=format&fit=crop",
          imageAlt: "Hospital Support Services",
        },
      ],
      otherServicesTitle: "Additional Care Settings",
      otherServicesList: [
        "Disability Care Support",
        "Mental Health Care Staffing",
        "Elderly Care Services",
        "School Support Staff",
        "Shelter & Summer Camp Staffing",
        "Youth Care Programs",
        "Dorm Support Services",
      ],
    },
    sectionD: {
      aboutTitle: "About Ahmed Human Services LLC",
      aboutImage: {
        src: "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=2069&auto=format&fit=crop",
        alt: "Ahmed Human Services Team",
      },
      aboutText: [
        "Ahmed Human Services LLC is a professional, compassionate, and dedicated human service staffing agency serving Columbus, Ohio. We work with different categories of disabilities, providing exceptional care to individuals at dorms, schools, shelters, summer camps, group homes, rehabilitation centers, residential care facilities, and mental health care settings.",
        "We pride ourselves on being the best human service staffing provider in Columbus, Ohio, thanks to the incredible relationships we've formed with our clients. Unlike our competitors, we're invested in developing a personal connection with each and every one of our customers by providing quality service and being available 24/7. Our strong commitment to being present and providing quality care and professionalism sets us apart.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Ahmed Human Services LLC",
      businessName: "Ahmed Human Services LLC",
      contact: {
        phone: "8573987451",
        phoneLabel: "(857) 398-7451",
        email: "ahmed@ahmedservicesllc.com",
        website: "https://www.ahmedservicesllc.org/",
        address: "3412 Greenwich Street, Columbus, OH 43224",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "3412 Greenwich Street, Columbus, OH 43224",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3055.8!2d-82.9988!3d40.0150!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88388e8e8e8e8e8e%3A0x8e8e8e8e8e8e8e8e!2s3412%20Greenwich%20St%2C%20Columbus%2C%20OH%2043224!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;